
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 20 20","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M11.667 6.667A3.332 3.332 0 108.334 10a3.332 3.332 0 003.333-3.333zM1.667 15v.833c0 .459.375.834.833.834h11.667a.836.836 0 00.833-.834V15c0-2.217-4.442-3.333-6.667-3.333-2.225 0-6.666 1.116-6.666 3.333zM15 8.333h3.333c.459 0 .834.375.834.834a.836.836 0 01-.834.833H15a.836.836 0 01-.833-.833c0-.459.375-.834.833-.834z"}})])
          )
        }
      }
    